/**
 * Централизованная конфигурация для системы Toast уведомлений
 * Все настройки тайминга и поведения тостов находятся здесь
 */

/**
 * Продолжительность жизни тоста (время отображения после появления)
 * @default 3000ms (3 секунды)
 */
export const TOAST_LIFE_DURATION = 3000;

/**
 * Продолжительность анимации появления тоста
 * @default 500ms (0.5 секунды)
 */
export const TOAST_APPEAR_DURATION = 500;

/**
 * Продолжительность анимации исчезновения тоста
 * @default 500ms (0.5 секунды)
 */
export const TOAST_DISAPPEAR_DURATION = 500;

/**
 * Задержка между появлением последовательных тостов
 * Предотвращает одновременное появление нескольких уведомлений
 * @default 250ms (0.25 секунды)
 */
export const TOAST_QUEUE_DELAY = 250;

/**
 * Максимальное количество одновременно видимых тостов
 * Остальные добавляются в очередь
 * @default 3
 */
export const TOAST_MAX_VISIBLE = 3;

/**
 * z-index для панели тостов
 * Должен быть выше header (1000)
 * @default 1001
 */
export const TOAST_Z_INDEX = 1001;

/**
 * Отступ от header'а
 * @default 0.75rem
 */
export const TOAST_TOP_OFFSET = '0.75rem';

/**
 * Отступ справа (для широких экранов)
 * @default 0.75rem
 */
export const TOAST_RIGHT_OFFSET = '0.75rem';

/**
 * Ширина тоста
 * @default 18.75rem (300px)
 */
export const TOAST_WIDTH = '18.75rem';

/**
 * Минимальная высота тоста
 * @default 3.5rem
 */
export const TOAST_MIN_HEIGHT = '3.5rem';

/**
 * Отступ между тостами
 * @default 0.75rem
 */
export const TOAST_SPACING = '0.75rem';

/**
 * Breakpoint для переключения на мобильную версию
 * @default 400px
 */
export const TOAST_MOBILE_BREAKPOINT = 400;
